import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";
import { CRM_CLASS_CREATE } from "../../apiRoutes";
import { refreshAllCurriculumData } from "./curriculumRefresh";

export interface CreateCrmClassRequest {
  schoolId: string;
  curriculumId: string;
  year: string;
  section: {
    name: string;
    noStudent: number;
  }[];
}

export interface CreateCrmClassResponse {
  data: {
    _id: string;
    schoolId: string;
    curriculumId: string;
    year: string;
    section: {
      _id: string;
      name: string;
      noOfStudent: number;
    }[];
    createdAt: string;
    updatedAt: string;
  };
}

interface UseCreateCrmClassMutationProps {
  onSuccess?: (data: CreateCrmClassResponse) => void;
  onError?: (error: any) => void;
}

const createCrmClass = async (data: CreateCrmClassRequest): Promise<CreateCrmClassResponse> => {
  const response = await axiosAuth.post<CreateCrmClassResponse>(CRM_CLASS_CREATE, data);
  return response.data;
};

export const useCreateCrmClassMutation = ({
  onSuccess,
  onError,
}: UseCreateCrmClassMutationProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation<CreateCrmClassResponse, Error, CreateCrmClassRequest>({
    mutationFn: createCrmClass,
    onSuccess: (data) => {
      // Invalidate and refetch CRM class data
      queryClient.invalidateQueries({ queryKey: ["crm-class"] });
      refreshAllCurriculumData(queryClient, data.data.schoolId);
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
